import { Expose } from "class-transformer";

export class UpdateWorkplaceTypeDto {
  @Expose()
  name: string;
}
